module.exports = {
  "customer": {},
};


// WEBPACK FOOTER //
// ./src/i18n/customer/en.js